import React, { Fragment, useState, useEffect } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import axios from "axios";
import { toast, Slide } from "react-toastify";

import {
    Input, Label, FormGroup,
    Row,
    Col,
} from "reactstrap";

const Step2 = ({stateAndCounties, setStateAndCounties}) => {
    const [state, setState] = useState('')
    const [counties, setCounties] = useState([])
    const [county, setCounty] = useState('')
    const [totalCountyCount, setTotalCountyCount] = useState(0);
    
    useEffect(() => {
        const totalCount = Object.values(stateAndCounties).reduce((acc, counties) => acc + counties.length, 0);
        setTotalCountyCount(totalCount);
       // console.log("Total form backned", totalCount)
    },[stateAndCounties])

    const handleStateChange = (val) => {
        setState(val)
        axios.get("https://leadfuzionlists.com/ajaxcall_countydata/",
            {
                params: {
                    field1_id: val,
                },
            }
        ).then(res => {
            setCounties(res?.data?.data)
            setCounty('all')
            setState(val)
        })
    }

    const handleCountyChange = (val) => {
        setCounty(val);
      
        setStateAndCounties((prevState) => {
          const selectedStateCounties = prevState[state] || [];
      
          if (totalCountyCount >= 10) {
            notify22("You can't add more than 10 counties overall.", "warning");
            return prevState; // Return the previous state without adding the new county.
          }
      
          if (!selectedStateCounties.includes(val)) {
            const newState = {
              ...prevState,
              [state]: [...selectedStateCounties, val],
            };
      
            setTotalCountyCount(totalCountyCount + 1); // Increment the total county count.
            return newState;
          } else {
            notify22(`County "${val}" is already included for ${state}.`, "warning");
          }
      
          return prevState;
        });
      };


    // const handleCountyChange = (val) => {
    //     setCounty(val)

    //     setStateAndCounties((prevState) => {
    //         const selectedStateCounties = prevState[state] || [];
    //         if (!selectedStateCounties.includes(val)) {
    //             return {
    //                 ...prevState,
    //                 [state]: [...selectedStateCounties, val],
    //             };
    //         } else {
    //             notify22(`County "${county}" is already included for ${state}.`, "warning")
    //         }
    //         return prevState;
    //     });

    // }

    const deleteSelectedCounty = (state, countyToDelete) => {
        setStateAndCounties((prevState) => {
            const newStateAndCounties = { ...prevState };
            const counties = newStateAndCounties[state] || [];
            const updatedCounties = counties.filter((county) => county !== countyToDelete);

            if (updatedCounties.length === 0) {
                delete newStateAndCounties[state];
            } else {
                newStateAndCounties[state] = updatedCounties;
            }

            return newStateAndCounties;
        });
    };

    const generateSelectedInfo = () => {
        return (
            <div>
                {Object.entries(stateAndCounties).map(([state, counties]) => (
                    <div key={state}>
                        {counties?.map((county) => (
                            <span className="badge rounded-pill text-capitalize me-2 mt-2 p-2" style={{ backgroundColor: "#002D62" }} key={county}>
                                {state} - {county}
                                <span className="fw-bold ms-2 text-info" role="button" onClick={() => deleteSelectedCounty(state, county)}>X</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        );
    };

    // const deleteSelectedState = (val) => {
    //     const newData = selectedData?.filter(v => {
    //         return val !== v
    //     })

    //     setSelectedData(newData)
    // }

    const notify22 = (msg, type) =>
        toast(msg, {
            transition: Slide,
            autoClose: 5000,
            position: "top-right",
            type: type,

        });

    return (
        <Fragment>
            <TransitionGroup>
                <CSSTransition component="div" classNames="TabsAnimation" appear={true}
                    timeout={0} enter={false} exit={false}>
                    <div className="form-wizard-content">
                        <h3 className="form-heading pt-3 pb-3">
                            Select State & County you are working
                            <p>You can Add upto 10</p>
                        </h3>
                        <Row className="g-2">
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="exampleEmail55">State</Label>
                                    <Input type="select" value={state} onChange={(e) => handleStateChange(e.target.value)}>
                                        <option value="">Select State</option>
                                        <option value="ak">Alaska</option>
                                        <option value="al">Alabama</option>
                                        <option value="ar">Arkansas</option>
                                        <option value="as">American Samoa</option>
                                        <option value="az">Arizona</option>
                                        <option value="ca">California</option>
                                        <option value="co">Colorado</option>
                                        <option value="ct">Connecticut</option>
                                        <option value="dc">District of Columbia</option>
                                        <option value="de">Delaware</option>
                                        <option value="fl">Florida</option>
                                        <option value="fm">Federated States of Micronesia</option>
                                        <option value="ga">Georgia</option>
                                        <option value="gu">Guam</option>
                                        <option value="hi">Hawaii</option>
                                        <option value="ia">Iowa</option>
                                        <option value="id">Idaho</option>
                                        <option value="il">Illinois</option>
                                        <option value="in">Indiana</option>
                                        <option value="ks">Kansas</option>
                                        <option value="ky">Kentucky</option>
                                        <option value="la">Louisiana</option>
                                        <option value="ma">Massachusetts</option>
                                        <option value="md">Maryland</option>
                                        <option value="me">Maine</option>
                                        <option value="mh">Marshall Islands</option>
                                        <option value="mi">Michigan</option>
                                        <option value="mn">Minnesota</option>
                                        <option value="mo">Missouri</option>
                                        <option value="mp">Northern Mariana Islands</option>
                                        <option value="ms">Mississippi</option>
                                        <option value="mt">Montana</option>
                                        <option value="nc">North Carolina</option>
                                        <option value="nd">North Dakota</option>
                                        <option value="ne">Nebraska</option>
                                        <option value="nh">New Hampshire</option>
                                        <option value="nj">New Jersey</option>
                                        <option value="nm">New Mexico</option>
                                        <option value="nv">Nevada</option>
                                        <option value="ny">New York</option>
                                        <option value="oh">Ohio</option>
                                        <option value="ok">Oklahoma</option>
                                        <option value="or">Oregon</option>
                                        <option value="pa">Pennsylvania</option>
                                        <option value="pr">Puerto Rico</option>
                                        <option value="ri">Rhode Island</option>
                                        <option value="pw">Palau</option>
                                        <option value="sc">South Carolina</option>
                                        <option value="sd">South Dakota</option>
                                        <option value="tx">Texas</option>
                                        <option value="tn">Tennessee</option>
                                        <option value="ut">Utah</option>
                                        <option value="va">Virginia</option>
                                        <option value="vi">Virgin Islands</option>
                                        <option value="vt">Vermont</option>
                                        <option value="wa">Washington</option>
                                        <option value="wi">Wisconsin</option>
                                        <option value="wv">West Virginia</option>
                                        <option value="wy">Wyoming</option>
                                        <option value="aa">Armed Forces Americas</option>
                                        <option value="ae">Armed Forces Africa</option>
                                        <option value="ap">Armed Forces Pacific</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="examplePassword22">County</Label>
                                    <Input type="select" value={county} onChange={(e) => handleCountyChange(e.target.value)}>
                                        <option value='all'>All</option>
                                        {counties?.map((v, k) => (
                                            <option value={v} key={k}>{v}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>

                            <Col md={12} className="mt-3">
                                <h5 className="mb-2">Selected State & Counties</h5>
                                {generateSelectedInfo()}
                                {/* {selectedData?.map((v, k) => (
                                    <Fragment key={k}>
                                        <span className="badge rounded-pill text-capitalize me-2 mt-2" style={{ backgroundColor: "#002D62" }}>
                                            {v} <span className="fw-bold ms-2 text-info" role="button" onClick={() => deleteSelectedState(v)}>X</span>
                                        </span>
                                    </Fragment>
                                ))} */}
                            </Col>
                        </Row>
                        {/* <Form>
                            <FormGroup row>
                                <Label for="exampleEmail" sm={3}>
                                    State:
                                </Label>
                                <Col sm={9}>
                                    <Input type="select" value={state} onChange={(e) => handleStateChange(e.target.value)}>
                                        <option value="">Select State</option>
                                        <option value="ak">Alaska</option>
                                        <option value="al">Alabama</option>
                                        <option value="ar">Arkansas</option>
                                        <option value="as">American Samoa</option>
                                        <option value="az">Arizona</option>
                                        <option value="ca">California</option>
                                        <option value="co">Colorado</option>
                                        <option value="ct">Connecticut</option>
                                        <option value="dc">District of Columbia</option>
                                        <option value="de">Delaware</option>
                                        <option value="fl">Florida</option>
                                        <option value="fm">Federated States of Micronesia</option>
                                        <option value="ga">Georgia</option>
                                        <option value="gu">Guam</option>
                                        <option value="hi">Hawaii</option>
                                        <option value="ia">Iowa</option>
                                        <option value="id">Idaho</option>
                                        <option value="il">Illinois</option>
                                        <option value="in">Indiana</option>
                                        <option value="ks">Kansas</option>
                                        <option value="ky">Kentucky</option>
                                        <option value="la">Louisiana</option>
                                        <option value="ma">Massachusetts</option>
                                        <option value="md">Maryland</option>
                                        <option value="me">Maine</option>
                                        <option value="mh">Marshall Islands</option>
                                        <option value="mi">Michigan</option>
                                        <option value="mn">Minnesota</option>
                                        <option value="mo">Missouri</option>
                                        <option value="mp">Northern Mariana Islands</option>
                                        <option value="ms">Mississippi</option>
                                        <option value="mt">Montana</option>
                                        <option value="nc">North Carolina</option>
                                        <option value="nd">North Dakota</option>
                                        <option value="ne">Nebraska</option>
                                        <option value="nh">New Hampshire</option>
                                        <option value="nj">New Jersey</option>
                                        <option value="nm">New Mexico</option>
                                        <option value="nv">Nevada</option>
                                        <option value="ny">New York</option>
                                        <option value="oh">Ohio</option>
                                        <option value="ok">Oklahoma</option>
                                        <option value="or">Oregon</option>
                                        <option value="pa">Pennsylvania</option>
                                        <option value="pr">Puerto Rico</option>
                                        <option value="ri">Rhode Island</option>
                                        <option value="pw">Palau</option>
                                        <option value="sc">South Carolina</option>
                                        <option value="sd">South Dakota</option>
                                        <option value="tx">Texas</option>
                                        <option value="tn">Tennessee</option>
                                        <option value="ut">Utah</option>
                                        <option value="va">Virginia</option>
                                        <option value="vi">Virgin Islands</option>
                                        <option value="vt">Vermont</option>
                                        <option value="wa">Washington</option>
                                        <option value="wi">Wisconsin</option>
                                        <option value="wv">West Virginia</option>
                                        <option value="wy">Wyoming</option>
                                        <option value="aa">Armed Forces Americas</option>
                                        <option value="ae">Armed Forces Africa</option>
                                        <option value="ap">Armed Forces Pacific</option>
                                    </Input>

                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label for="exampleEmail" sm={3}>
                                    County:
                                </Label>
                                <Col sm={9}>
                                    <Input type="select" value={county} onChange={(e) => setCounty(e.target.value)}>
                                        <option value='all'>All</option>
                                        {counties?.map((v, k) => (
                                            <option value={v} key={k}>{v}</option>
                                        ))}
                                    </Input>
                                </Col>
                            </FormGroup>

                        </Form> */}

                    </div>
                </CSSTransition>
            </TransitionGroup>
        </Fragment>
    );
}
export default Step2;
